import { defineMessages } from 'react-intl';

const autoLinkConsentMessages = defineMessages({
  pageTitle: {
    id: 'autoLinkConsent.pageTitle',
    defaultMessage: 'Your profiles have been merged',
    description: 'The page title for auto link consent.',
  },
  pageDescription: {
    id: 'autoLinkConsent.pageDescription',
    defaultMessage:
      'You already have an AWS Training & Certification profile with <b>{email}</b>. It was last accessed on {date} using {idp}. We have merged both profiles so that your training activity and data are saved. ',
    description: 'The page description for auto link consent.',
  },
  button: {
    id: 'autoLinkConsent.button',
    defaultMessage: 'Continue',
    description: 'The button text for auto link consent.',
  },
});

export default autoLinkConsentMessages;
